import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { ApiService } from 'app/core/services/api.service';
import { environment } from 'enviroments/environment';
import { CarreraModel, ListadoCarrerasDTO } from 'app/modules/models/carreras.model';
import { ResponseInterface } from 'app/modules/models/response.model';
import { Tipologia } from 'app/modules/models/tipologia.model';

@Injectable({providedIn: 'root'})
export class RegistrosService {
    private apiUrl:string = environment.API_SERVER_URL

    constructor(
        private api: ApiService,
        private _httpClient:HttpClient
    ) { }

    // Signal que se incrementa cuando se crean/actualizan registros
    // Signal para reaccionar a cambios en listados.
    private _cambiosRegistrosSignal = signal(0);
    public readonly cambiosRegistrosSignal = this._cambiosRegistrosSignal.asReadonly();

    getTipologias(tipologiaId:number): Promise <Tipologia>{
        const url = `/tipologias/${tipologiaId}`
        return new Promise((resolve, reject) => {
            this.api.GetMethod(url, {}, 'Error al obtener datos')
                .subscribe( (tipologia: Tipologia[]) => {
                    resolve( tipologia[0])
                }, error => reject(error))
        })
    }


    async getPalabrasClave() {
        const _typology = environment.TIPOLOGIA_PALABRAS_CLAVE
        const data =  await this.getTipologias(_typology)
        return data.tipologias
    }


    async getListadoCarreras(params: any): Promise<ListadoCarrerasDTO> {
        const url = `/carrera`
        return new Promise((resolve, reject) => {
            this.api.GetMethod(url, params, 'Error al obtener datos')
                .subscribe( (data: ListadoCarrerasDTO) => {
                    resolve( data)
                }, error => reject(error))
        })
    }

    /**
     * Inserta un registro de carrera
     */
    insertarRegistro(model: CarreraModel): Promise<any> {
        const url = `/carrera`;

        return new Promise((resolve, reject) => {
            this.api.PostMethod(url, model, {}, 'Error al guardar el registro')
                .subscribe(
                    (data: any) => {
                        // Notificar a los observadores que hubo cambios
                        try { this._cambiosRegistrosSignal.update(v => v + 1); } catch {}
                        resolve(data);
                    },
                    (error) => reject(error)
                );
        });
    }

    /**
     * Actualiza un registro de carrera
     */
    actualizarRegistro(model: CarreraModel): Promise<any> {
        const url = `/carrera/${model.carreraId}`;

        return new Promise((resolve, reject) => {
            this.api.PutMethod(url, model, {}, 'Error al actualizar el registro')
                .subscribe(
                    (data: any) => {
                        // Notificar a los observadores que hubo cambios
                        try { this._cambiosRegistrosSignal.update(v => v + 1); } catch {}
                        resolve(data);
                    },
                    (error) => reject(error)
                );
        });
    }

    // Construir string de palabras clave
    buildPalabrasClaveString(tuplas: Tipologia[] = []): string {
        if (!Array.isArray(tuplas) || tuplas.length === 0) {
            return '';
        }
        return tuplas
            .filter(t => (t.descripcion || '').toString().trim() !== '')
            .map(t => `(${t.tipologiaId ?? 0},${t.descripcion ?? ''})`)
            .join('-');
    }

    descargarInforme() {
        const url = `/file/reporte`;
        return new Promise((resolve, reject) => {
            this.api.PostMethod(url, {}, {}, 'Error al descargar informe')
                .subscribe((response: ResponseInterface) => {
                        resolve(response);
                    },
                    (error) => reject(error)
                );
        });
    }

    descargarReporteDeRegistros(): Promise<Blob> {
        const url = `/file/reporte_registros`;
        return new Promise((resolve, reject) => {
            this._httpClient.get(`${this.api.serverUrl}${url}`, { responseType: 'blob' })
                .subscribe((response: Blob) => {
                        resolve(response);
                    },
                    (error) => reject(error)
                );
        });
    }

    subirPlantilla(archivo: File) {
        const url = `/file/plantilla`;
        const formData = new FormData();
        formData.append('archivo', archivo);
        return new Promise((resolve, reject) => {
            this.api.PostMethod(url, formData, {}, 'Error al subir plantilla')
                .subscribe(
                    (response: ResponseInterface) => resolve(response),
                    (error) => reject(error)
                );
        });
    }


    getBitacoraInfome(){
        const url = `/file/informes_bitacora`
        return new Promise((resolve, reject) => {
            this.api.GetMethod(url, {}, 'Error al obtener historial de Informes')
                .subscribe( (data: ResponseInterface) => {
                    resolve( data)
                }, error => reject(error))
        })
    }

    eliminarRegistro(carreraUuid:string, comentario: string){
        const url = `/carrera/${carreraUuid}?comentario=${comentario}`
        return new Promise((resolve, reject) => {
            this.api.DeleteMethod(url, {}, 'Error al eliminar registro')
                .subscribe( (data: ResponseInterface) => {
                    resolve( data)
                }, error => reject(error))
        })
    }

    publicarRegistro(carreraUuid:string){
        const url = `/carrera/publicar/${carreraUuid}`
        return new Promise((resolve, reject) => {
            this.api.PutMethod(url, {}, 'Error al publicar registro')
                .subscribe( (data: ResponseInterface) => {
                    resolve( data)
                }, error => reject(error))
        })
    }

    getBitacoraRegistro(entidadUuid:string){
        const url = `/bitacora?entidadUuid=${entidadUuid}`
        return new Promise((resolve, reject) => {
            this.api.GetMethod(url, {}, 'Error al obtener Bitácora')
                .subscribe( (data: any) => {
                    resolve( data)
                }, error => reject(error))
        })
    }

}
